/* eslint-disable camelcase */
import { actions as chatActions } from 'react/api/actions/chat';
import { fromJS } from 'immutable';

const initialState = fromJS({});

export default (state = initialState, action) => {
  switch (action.type) {
    case chatActions.toggleChatWindow: {
      const { chatId } = action.payload;
      const getActualStatus = state.getIn([`chatWindow_${chatId}`, 'closed']);

      return state.setIn([`chatWindow_${chatId}`, 'closed'], !getActualStatus);
    }
    case chatActions.removeChatWindow: {
      const { chatId } = action.payload;

      return state.removeIn([`chatWindow_${chatId}`]);
    }
    case chatActions.addNewChatWindow: {
      const {
        from,
        fromName,
        messages,
        name,
        ticket = null
      } = action.payload;

      const chatId = ticket ? ticket.ticketId : `${Monet.Session.User.id}-${from}`;

      const newChat = {
        id: chatId,
        name: name || fromName || from,
        userName: fromName || from,
        closed: false,
        to: Monet.Session.User.id,
        from,
        messages: messages || [],
        ticket: fromJS(ticket)
      };

      return state.setIn([`chatWindow_${chatId}`], fromJS(newChat));
    }
    case chatActions.updateSingleChat: {
      const chat = action.payload;
      const { chatId } = chat;
      const findChat = state.get(`chatWindow_${chatId}`);

      return findChat ? state.mergeDeepIn([`chatWindow_${chatId}`], fromJS(chat)) : state;
    }
    case chatActions.updateChatWindows: {
      const newChats = action.payload;

      return state.mergeDeep(newChats);
    }
    case chatActions.addMessage: {
      const { chatId, message } = action.payload;
      const findChat = state.getIn([`chatWindow_${chatId}`]);

      return findChat ? state
        .updateIn([`chatWindow_${chatId}`, 'messages'],
          (messages) => messages.push(fromJS(message))) : state;
    }
    case chatActions.updateSingleMessage: {
      const { chatId, message } = action.payload;

      const chatMessages = state.getIn([`chatWindow_${chatId}`, 'messages'], []);
      const messageToUpdateIndex = chatMessages.findIndex((msg) => msg.get('id') === message.id);

      return messageToUpdateIndex > -1 ? state.mergeIn(
        [
          `chatWindow_${chatId}`,
          'messages',
          messageToUpdateIndex
        ],
        fromJS(message)
      ) : state;
    }
    case chatActions.updateMessages: {
      const chat = action.payload;
      const { chatId, messagesIds = [], dataToUpdate = {} } = chat;

      return messagesIds.length ? state
        .updateIn([`chatWindow_${chatId}`, 'messages'], (actualMessages) => actualMessages
          .map((message) => (messagesIds.includes(message.get('id'))
            ? message.merge(fromJS(dataToUpdate)) : message))) : state;
    }
    case chatActions.receiveACall: {
      const { userId, name } = action.payload;
      const chatId = `${Monet.Session.User.id}-${userId}`;

      const activeCall = {
        userId
      };

      const newChat = {
        id: `${Monet.Session.User.id}-${userId}`,
        name: 'Greenmile.Chat.Title.SupportRequest',
        userName: name,
        closed: false,
        to: Monet.Session.User.id,
        from: userId,
        activeCall,
        messages: []
      };

      return state.setIn([`chatWindow_${chatId}`], fromJS(newChat));
    }
    case chatActions.toggleCallStatus: {
      const { chatId } = action.payload;

      return state.setIn([`chatWindow_${chatId}`, 'activeCall'], null);
    }
    default:
      return state;
  }
};
